import React from "react";
import { StarIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { TransformCTA } from "../TransformCTA";
import { testimonials } from "../../data/content";
export function Testimonials() {
  return <section className="bg-paper px-4 py-16 sm:py-24" data-id="element-287" data-mp="3mf7ly4stt268">
      <div className="mx-auto max-w-6xl" data-id="element-288" data-mp="3r80uz4vbuwo4">
        <SectionHeading kicker="What professionals say" title="What professionals are looking for in aesthetic laser education" data-id="element-289" data-mp="3r93m9dwkb14k" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-290" data-mp="429s8fmmn5ki">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-navy-900/10" data-id="element-291" data-mp="92xkf4mldsgb">
              <div className="flex items-center gap-4" data-id="element-292" data-mp="dzo19u680s2s">
                <img src={t.image} alt={`Photo of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-electric/30" loading="lazy" data-id="element-293" data-mp="2atiqm9zo1mhv" />
                <figcaption data-id="element-294" data-mp="1sm3xhygauch8">
                  <p className="font-bold text-ink" data-id="element-295" data-mp="1smdq7tsqaxqm">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-296" data-mp="1nt13jp7m110i">{t.role}</p>
                </figcaption>
              </div>
              <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-297" data-mp="1iv9dl0qizoyy">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-cta text-cta" aria-hidden="true" data-id="element-298" data-mp="2bj55ls55gspe" data-mpi={i} />)}
              </div>
              <p className="mt-3 font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-299" data-mp="26ldg14rz9iod">“{t.title}”</p>
              <blockquote className="mt-2 text-base text-muted" data-id="element-300" data-mp="22he3sydqd60t">“{t.quote}”</blockquote>
            </figure>)}
        </div>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs text-muted/80" data-id="element-301" data-mp="1xlyn7yoc8w0p">
          Testimonials are illustrative and must be replaced with verified customer information before publication.
        </p>

        <TransformCTA headline="Join professionals organizing their laser education" label="Explore The Collection" data-id="element-302" data-mp="nlmhlwi7ejmp" />
      </div>
    </section>;
}